"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertGoogleToHTML;
exports.convertGoogleDocToHTML = exports.parseList = exports.applyInlineStyles = exports.applyBlockStyles = exports.getFlatChildNodes = exports.wrapNode = exports.wrapNodeInline = exports.wrapNodeAnchor = exports.elements = exports.styles = exports.CONVERT_GOOGLE_TO_HTML = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _isValidPasteContent = _interopRequireDefault(require("../utils/isValidPasteContent"));

var _params = require("hub-http/helpers/params");

var _parseHTML = _interopRequireDefault(require("../utils/parseHTML"));

var CONVERT_GOOGLE_TO_HTML = 'google';
exports.CONVERT_GOOGLE_TO_HTML = CONVERT_GOOGLE_TO_HTML;
var styles = {
  BOLD: '700',
  ITALIC: 'italic',
  STRIKETHROUGH: 'line-through',
  SUPERSCRIPT: 'super',
  SUBSCRIPT: 'sub'
};
exports.styles = styles;
var elements = {
  ANCHOR: 'a',
  BOLD: 'strong',
  ITALIC: 'em',
  STRIKETHROUGH: 'del',
  SUPERSCRIPT: 'sup',
  SUBSCRIPT: 'sub',
  H2: 'h2',
  H3: 'h3'
};
exports.elements = elements;
var HEADERS = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
var LISTS = ['OL', 'UL', 'LI'];
var TABLES = ['TR', 'TD', 'TABLE'];
var CHILD_NODES_OVERRIDES = ['P', 'A', 'SPAN'].concat(HEADERS, LISTS, TABLES);
var DOC_WRAPPER = /docs-internal-guid/;
var COMMENT_HREF = /^#cmnt_ref\d+|#cmnt\d+/;
var GOOGLE_REDIRECT = /^https?:\/\/www.google.com\/url\?/;
var LIST_CLASS_PATTERN = /lst-kix_(\w*)-(\d*)/;
var listMap = {};

var badHref = function badHref(href) {
  return COMMENT_HREF.test(href);
};

var removeGoogleRedirect = function removeGoogleRedirect(href) {
  if (GOOGLE_REDIRECT.test(href)) {
    var query = href.slice(href.indexOf('?') + 1);
    var params = (0, _params.parse)(query);
    return params.q || href;
  }

  return href;
};
/**
 * this is the internal version of https://www.github.com/aem/docs-soap
 */


var isCommentsStyle = function isCommentsStyle(_ref) {
  var border = _ref.border,
      margin = _ref.margin;
  return border.indexOf('1px') !== -1 && border.indexOf('solid') !== -1 && border.indexOf('black') !== -1 && margin === '5px';
};

var isCommentStyle = function isCommentStyle(style) {
  if (!style) return false;
  var color = style.color,
      fontFamily = style.fontFamily,
      fontSize = style.fontSize,
      lineHeight = style.lineHeight,
      margin = style.margin,
      padding = style.padding,
      textAlign = style.textAlign;
  return color === 'rgb(0, 0, 0)' && fontFamily === 'Arial' && fontSize === '11pt' && lineHeight === '1' && margin === '0px' && padding === '0px' && textAlign === 'left';
};

var isTableContainer = function isTableContainer(node) {
  return node.nodeName === 'DIV' && node.childNodes.length === 1 && TABLES.has(node.childNodes[0].nodeName);
};

var childrenHaveCommentStyle = function childrenHaveCommentStyle(_ref2) {
  var childNodes = _ref2.childNodes;

  for (var i = 0; i < childNodes.length; i++) {
    if (!isCommentStyle(childNodes[i].style)) {
      return false;
    }
  }

  return true;
};

var wrapNodeAnchor = function wrapNodeAnchor(node, href) {
  // TODO investigate empty span return
  if (badHref(href)) {
    return document.createElement('span');
  } else if (href === '') {
    return Array.isArray(node) ? node : node.cloneNode(true);
  }

  var anchor = document.createElement('a');
  anchor.href = removeGoogleRedirect(href);

  if (Array.isArray(node)) {
    node.forEach(function (n) {
      return anchor.appendChild(n.cloneNode(true));
    });
  } else {
    anchor.appendChild(node.cloneNode(true));
  }

  return anchor;
};

exports.wrapNodeAnchor = wrapNodeAnchor;

var wrapNodeInline = function wrapNodeInline(node, style) {
  var el = document.createElement(style);
  el.appendChild(node.cloneNode(true));
  return el;
};

exports.wrapNodeInline = wrapNodeInline;

var wrapNode = function wrapNode(inner, result) {
  var newNode = result.cloneNode(true);
  var stylePropertyPairs = [['fontWeight', 'BOLD'], ['fontStyle', 'ITALIC'], ['textDecoration', 'UNDERLINE'], ['textDecoration', 'STRIKETHROUGH'], ['verticalAlign', 'SUPERSCRIPT'], ['verticalAlign', 'SUBSCRIPT']];

  if (inner && inner.style) {
    stylePropertyPairs.forEach(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          prop = _ref4[0],
          style = _ref4[1];

      if (inner.style[prop] === styles[style]) {
        newNode = wrapNodeInline(newNode, elements[style]);
      }
    });
  }

  return newNode;
};

exports.wrapNode = wrapNode;

var getFlatChildNodes = function getFlatChildNodes(node) {
  var childNodes = [];

  function getChildNodes(parent) {
    var children = (0, _toConsumableArray2.default)(parent.childNodes);
    children.forEach(function (child) {
      childNodes.push(child);

      if (child.childNodes.length) {
        getChildNodes(child);
      }
    });
  }

  if (node.childNodes.length) {
    getChildNodes(node);
  }

  return childNodes;
};
/**
 * Takes a block-level element (paragraphs and bullets) and applies inline styles as necessary
 */


exports.getFlatChildNodes = getFlatChildNodes;

var applyBlockStyles = function applyBlockStyles(dirty) {
  var node = dirty.cloneNode(true);
  var newNode = document.createTextNode(node.textContent);
  var styledNode;

  if (node.childNodes.length) {
    if (node.className === 'title') {
      newNode = wrapNodeInline(newNode, elements.H2);
    } else if (node.className === 'subtitle') {
      newNode = wrapNodeInline(newNode, elements.H3);
    } else if (node.childNodes[0].style) {
      styledNode = node.childNodes[0];
    }
  }

  newNode = wrapNode(styledNode, newNode);
  return newNode;
};
/**
 * parse out the inline style properties and wrap the text in HTML elements instead
 */


exports.applyBlockStyles = applyBlockStyles;

var applyInlineStyles = function applyInlineStyles(dirty) {
  var node = dirty.cloneNode(true);
  var newNode = document.createTextNode(node.textContent);
  var styledNode = node;
  var anchorNode;

  if (node.childNodes && node.childNodes[0] && node.childNodes[0].nodeName === 'A') {
    anchorNode = node.childNodes[0];
  }

  if (anchorNode) {
    newNode = wrapNodeAnchor(newNode.cloneNode(true), anchorNode.href);

    if (anchorNode.childNodes[0] && anchorNode.childNodes[0].style) {
      styledNode = anchorNode.childNodes[0];
    }
  }

  newNode = wrapNode(styledNode, newNode);
  return newNode;
}; // Only used in parseList - mutates newWrapper


exports.applyInlineStyles = applyInlineStyles;

var handleExportedLists = function handleExportedLists(className, newNode, newWrapper) {
  var listClasses = LIST_CLASS_PATTERN.exec(className);

  if (listClasses) {
    var _listClasses = (0, _slicedToArray2.default)(listClasses, 3),
        key = _listClasses[1],
        depth = _listClasses[2];

    if (className.indexOf('start') !== -1) {
      newWrapper.appendChild(newNode);

      if (listMap[key]) {
        listMap[key][depth] = newWrapper;
        listMap[key]["" + (depth - 1)].appendChild(newWrapper);
        return true;
      } // depth 0 -> make new entry AND allow node to be added to main nodes (entry point of this list)


      listMap[key] = (0, _defineProperty2.default)({}, depth, newWrapper);
      return false;
    }

    listMap[key][depth].appendChild(newNode);
    return true;
  }

  return false;
};

var parseList = function parseList(node) {
  var className = node.className,
      childNodes = node.childNodes,
      nodeName = node.nodeName;
  var newWrapper = document.createElement(nodeName);
  var newNode = document.createDocumentFragment();
  var items = [];

  for (var i = 0; i < childNodes.length; i++) {
    /* eslint-disable no-use-before-define */
    items.push.apply(items, (0, _toConsumableArray2.default)(getCleanNode(childNodes[i])));
    /* eslint-enable no-use-before-define */
  }

  items.map(function (i) {
    return newNode.appendChild(i);
  });

  if (handleExportedLists(className, newNode, newWrapper)) {
    return [];
  }

  newWrapper.appendChild(newNode);
  return [newWrapper];
};

exports.parseList = parseList;

var isEmptyNode = function isEmptyNode(node) {
  if (node.nodeName === '#text') {
    return node.textContent === '';
  }

  return node.innerHTML === '';
};

var getCleanNode = function getCleanNode(node) {
  // recursive base case: 0 or 1 child nodes, we always know how to handle this case
  if (node.childNodes && !isTableContainer(node) && (node.childNodes.length <= 1 || CHILD_NODES_OVERRIDES.includes(node.nodeName) || node.nodeName === 'DIV' && isCommentsStyle(node.style)) && !DOC_WRAPPER.test(node.id)) {
    var newWrapper = null; // create a new target node

    var newNode = document.createTextNode(node.textContent);

    if (LISTS.includes(node.nodeName) || TABLES.includes(node.nodeName) || HEADERS.includes(node.nodeName)) {
      return parseList(node);
    } else if (node.nodeName === 'P') {
      // Google is pretty consistent about new paragraphs in <p></p> tags tho...
      if (node.childNodes.length > 1) {
        return parseList(node);
      }

      newWrapper = document.createElement('p');
      var childNodes = getFlatChildNodes(node);

      if (childNodes.length === 0) {
        return [];
      } else if (childNodes.length > 1) {
        newNode = getCleanNode(node.childNodes[0]);
      } else {
        newNode = applyBlockStyles(node);
      }
    } else if (node.nodeName === '#text') {
      return [newNode];
    } else if (node.nodeName === 'BR' || node.nodeName === 'HR') {
      newNode = document.createElement(node.tagName);
      return [newNode];
    } else if (node.nodeName === 'IMG') {
      return [newNode];
    } else if (node.nodeName === 'A') {
      if (node.childNodes.length === 0) {
        return [];
      } // wrap the child node(s) in an anchor


      var cleanChildren = [];

      for (var i = 0; i < node.childNodes.length; i++) {
        var cleanNode = getCleanNode(node.childNodes[i]);
        cleanChildren.push.apply(cleanChildren, (0, _toConsumableArray2.default)(cleanNode));
      }

      newNode = wrapNodeAnchor(cleanChildren, node.href);
      return [newNode];
    } else if (node.nodeName === 'DIV' && isCommentsStyle(node.style) && childrenHaveCommentStyle(node)) {
      return [];
    } else if (node.nodeName === 'SPAN') {
      // ignore empty spans
      if (node.childNodes.length === 0) {
        return [];
      } // style the child node(s) of the span


      var _cleanChildren = [];

      for (var _i = 0; _i < node.childNodes.length; _i++) {
        var _cleanNode = getCleanNode(node.childNodes[_i]);

        _cleanChildren.push.apply(_cleanChildren, (0, _toConsumableArray2.default)(_cleanNode));
      }

      var tempInnerWrapper = document.createElement('span');

      if (_cleanChildren.length === 1) {
        tempInnerWrapper = _cleanChildren[0];
      }

      newNode = wrapNode(node, tempInnerWrapper);

      if (_cleanChildren.length > 1) {
        // remove temp inner wrapper
        newNode = newNode.cloneNode(false);

        _cleanChildren.forEach(function (child) {
          return newNode.appendChild(child);
        });
      }

      return [newNode];
    } else {
      newWrapper = node.cloneNode(false);
      newNode = node.childNodes.length ? getCleanNode(node.childNodes[0]) : [];
    }

    if (newWrapper) {
      if (Array.isArray(newNode)) {
        newNode.forEach(function (n) {
          if (!isEmptyNode(n)) newWrapper.appendChild(n);
        });
      } else {
        if (!isEmptyNode(newNode)) newWrapper.appendChild(newNode);
      }

      if (newWrapper.innerHTML === '') return [];
      return [newWrapper];
    } // if it's nothing that we want to specifically handle in the composer just return the node,
    // draft-js will clean it up for us


    return [node.cloneNode(true)];
  }

  if (node.childNodes) {
    var nodes = [];

    for (var _i2 = 0; _i2 < node.childNodes.length; _i2++) {
      var nextNode = getCleanNode(node.childNodes[_i2]);
      nodes.push.apply(nodes, (0, _toConsumableArray2.default)(nextNode));
    }

    return nodes;
  }

  return [node];
};

var shouldKeepNode = function shouldKeepNode(node) {
  // Windows clipboards append the <!--StartFragment--> and <!--EndFragment--> which we don't want
  if (node.nodeName === '#comment') {
    return false;
  } // Ignore meta and style tags


  if (node.nodeName === 'META' || node.nodeName === 'STYLE') {
    return false;
  } // Windows clipboards seem to insert a stray space character at the start and end of body tag


  if (node.nodeName === '#text' && node.parentNode.nodeName === 'BODY' && (node.previousSibling === null && node.nextSibling || node.previousSibling && node.nextSibling === null)) {
    return false;
  }

  return true;
};

var getCleanDocument = function getCleanDocument(dirty) {
  var body = document.createElement('body');
  var nodes = dirty.childNodes;
  var cleanNodes = [];

  for (var i = 0; i < nodes.length; i++) {
    if (shouldKeepNode(nodes[i])) {
      var cleanNode = getCleanNode(nodes[i]);
      cleanNodes.push.apply(cleanNodes, (0, _toConsumableArray2.default)(cleanNode));
    }
  }

  cleanNodes.map(function (node) {
    return body.appendChild(node.cloneNode(true));
  });
  listMap = {};
  return body;
};

function convertGoogleToHTML(clipboardContent) {
  (0, _isValidPasteContent.default)(clipboardContent);
  return getCleanDocument((0, _parseHTML.default)(clipboardContent.replace(/(\r\n|\n|\r)/, ''))).outerHTML;
}

var convertGoogleDocToHTML = function convertGoogleDocToHTML(doc) {
  return convertGoogleToHTML(doc);
};

exports.convertGoogleDocToHTML = convertGoogleDocToHTML;